export default {  
    "Forgot the password": "Forgot the password",
    "Enter": "Enter",
    "Password": "Password",
    "Forgot password?": "Forgot password?",
    "Back": "Back",
    "Equipments": "Equipments",
    "Settings": "Settings",
    "Filters": "Filters",
    "Search": "Search",
    "Device model": "Device model",
    "Software version": "Software version",
    "Clear": "Clear",
    "Filter by serial number, module ...": "Filter by serial number, module ...",
    "Register date": "Register date",
    "Mode": "Mode",
    "Client": "Client",
    "Modules": "Modules",
    "History": "History",
    "Serial number": "Serial number",
    "Register": "Register",
    "Regulatory target": "Regulatory target",
    "Last maintenance": "Last maintenance",
    "Software version": "Software version",
    "Equipment": "Equipment",
    "Activation keys": "Activation keys",
    "Change reason": "Change reason",
    "Responsible": "Responsible",
    "Fill in the fields below to register a new equipment": "Fill in the fields below to register a new equipment",
    "Model": "Model",
    "Regulatory mode": "Regulatory mode",
    "Identity file": "Identity file",
    "File specifications": "File specifications",
    "The file must be in .json format with the following structure": "The file must be in .json format with the following structure",
    "Contains 'device' object or keys at root": "Contains 'device' object or keys at root",
    "All keys below must not be empty": "All keys below must not be empty",
    "Logout": "Logout",
    "Confirm Associate": "Confirm Associate",
    "Send order": "Send order",
    "Associate": "Associate",
    "Modules order": "Modules order",
    "Fill in the data below to associate the equipment with the distributor:": "Fill in the data below to associate the equipment with the distributor:",
    "Distributor":"Distributor",
    "Select an address":"Select an address",
    "Include new address":"Include new address",
    "Street":"Street",
    "Number":"Number",
    "State": "State",
    "Complement":"Complement",
    "District":"District",
    "UF":"UF",
    "Country":"Country",
    'Register date':'Register date',
    'Mode':'Mode',
    'Pim serial number':'Pim serial number',
    'AM serial number':'AM serial number',
    'Ventilation serial number':'Ventilation serial number',
    'Pim mac address one':'Pim mac address one',
    'Pim mac address two':'Pim mac address two',
    "We will get back to you as soon as possible about your order.": "We will get back to you as soon as possible about your order.",
    "Modules order has created successfully!": "Modules order has created successfully!",
    "Confirm the changes": "Confirm the changes",
    "Before changes": "Before changes",
    "After changes": "After changes",
}